const isPrivateEntity = (entity) => entity && entity.privacy;

export default isPrivateEntity;
